import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteShift } from "../../../axios/Shift/ShiftApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import { useAuth } from "../../../context/AuthContext";

const DeleteShiftDialog = (props) => {
  const { t } = useTranslation();
  const { isAdmin } = useAuth();
  const [loading, setLoading] = useState(false);
  const { open, handleClose, selectedDeleteShift, onRefresh } = props;

  const handleCloseDialog = () => {
    if (loading) return;
    handleClose();
  };

  const handleRemove = async () => {
    if (!isAdmin) return;
    setLoading(true);
    try {
      const payload = {
        ...selectedDeleteShift,
        langId: localStorage.getItem("i18nextLngId"),
      };
      const response = await deleteShift(payload);

      if (
        response.data.message === "Successful" ||
        response.data.message === "Thành công"
      ) {
        toast.success(t("common.delete-shift-successfully"));
        handleClose();
        onRefresh?.();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open={open}
      variant="delete"
      title={t("common.content-178", {
        shiftName: selectedDeleteShift?.shiftName || "",
      })}
      subtitle={t("common.content-179")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleRemove}
    />
  );
};

export default DeleteShiftDialog;
